/* ==========================================================================
   CL - Vitrina Experiencia - comportamiento
   - Slider horizontal (swipe en mobile + flechas por pagina en desktop)
   - Video de fondo:
       - Desktop (hover): se reproduce al pasar el cursor por la card.
       - Mobile/tactil: se reproduce el video de la card que se esta viendo
         (al entrar la vitrina en pantalla) y se pausa cuando deja de verse.
   ========================================================================== */

(function () {
	'use strict';

	var reduceMotion =
		window.matchMedia &&
		window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	function isTouch() {
		return window.matchMedia && window.matchMedia('(hover: none)').matches;
	}

	function playVideo(card) {
		var v = card.querySelector('.clxp__video');
		if (!v) return;
		card.classList.add('is-playing');
		var p = v.play();
		if (p && typeof p.catch === 'function') {
			p.catch(function () {
				/* autoplay bloqueado: se queda el poster/imagen */
			});
		}
	}

	function pauseVideo(card, reset) {
		var v = card.querySelector('.clxp__video');
		if (!v) return;
		card.classList.remove('is-playing');
		try {
			v.pause();
			if (reset) v.currentTime = 0;
		} catch (e) {}
	}

	function setupFades(scroller, host) {
		function update() {
			var canScroll = scroller.scrollWidth > scroller.clientWidth + 8;
			var atStart = scroller.scrollLeft <= 8;
			var atEnd =
				scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 8;
			host.classList.toggle('clxp--fade-left', canScroll && !atStart);
			host.classList.toggle('clxp--fade-right', canScroll && !atEnd);
		}
		scroller.addEventListener('scroll', update, { passive: true });
		update();
		return update;
	}

	function initSection(root) {
		if (root.dataset.clInit === 'true') return;
		root.dataset.clInit = 'true';

		var viewport = root.querySelector('.clxp__viewport');
		var track = root.querySelector('.clxp__track');
		var prev = root.querySelector('.clxp__arrow--prev');
		var next = root.querySelector('.clxp__arrow--next');
		if (!track || !viewport) return;

		var cards = [].slice.call(track.querySelectorAll('.clxp__card'));

		/* ---------- Slider ---------- */

		function metrics() {
			var card = track.querySelector('.clxp__card');
			if (!card) return null;
			var styles = window.getComputedStyle(track);
			var gap = parseFloat(styles.columnGap || styles.gap) || 0;
			var cardStep = card.offsetWidth + gap;
			/* + gap: la ultima card de la vista no lleva gap (3 cards exactas = 3) */
			var perView = Math.max(1, Math.floor((track.clientWidth + gap) / cardStep));
			return { cardStep: cardStep, perView: perView };
		}

		function pageWidth(m) {
			return m.cardStep * m.perView;
		}

		function updateArrows() {
			if (!prev || !next) return;
			/* El track tiene padding lateral y el snap deja la primera card a
			   esa distancia (no en 0): la tolerancia incluye el padding. */
			var cs = window.getComputedStyle(track);
			var padL = parseFloat(cs.paddingLeft) || 0;
			var padR = parseFloat(cs.paddingRight) || 0;
			var maxScroll = track.scrollWidth - track.clientWidth - padR - 6;
			prev.disabled = track.scrollLeft <= padL + 6;
			next.disabled = track.scrollLeft >= maxScroll;
		}

		var updateFades = setupFades(track, viewport);

		if (prev) {
			prev.addEventListener('click', function () {
				var m = metrics();
				if (m) track.scrollBy({ left: -pageWidth(m), behavior: 'smooth' });
			});
		}
		if (next) {
			next.addEventListener('click', function () {
				var m = metrics();
				if (m) track.scrollBy({ left: pageWidth(m), behavior: 'smooth' });
			});
		}

		/* ---------- Video: desktop (hover) ---------- */

		if (!isTouch()) {
			cards.forEach(function (card) {
				card.addEventListener('mouseenter', function () {
					if (reduceMotion) return;
					playVideo(card);
				});
				card.addEventListener('mouseleave', function () {
					pauseVideo(card, true);
				});
			});
		}

		/* ---------- Video: mobile/tactil (card visible) ---------- */

		// ?La seccion esta a la vista?
		function sectionVisible() {
			var r = root.getBoundingClientRect();
			var vh = window.innerHeight || document.documentElement.clientHeight;
			return r.top < vh * 0.85 && r.bottom > vh * 0.15;
		}

		// Fraccion del ancho de la card visible dentro del viewport del slider.
		function visibleRatio(card) {
			var cr = card.getBoundingClientRect();
			var vr = viewport.getBoundingClientRect();
			var left = Math.max(cr.left, vr.left);
			var right = Math.min(cr.right, vr.right);
			var shown = Math.max(0, right - left);
			return cr.width ? shown / cr.width : 0;
		}

		function updatePlayback() {
			if (reduceMotion) return;
			if (!sectionVisible()) {
				cards.forEach(function (c) {
					pauseVideo(c, false);
				});
				return;
			}
			// La card mas visible se reproduce; las demas se pausan.
			var bestIdx = -1;
			var bestRatio = 0.5; // debe verse al menos la mitad
			cards.forEach(function (card, i) {
				var ratio = visibleRatio(card);
				if (ratio > bestRatio) {
					bestRatio = ratio;
					bestIdx = i;
				}
			});
			cards.forEach(function (card, i) {
				if (i === bestIdx) {
					if (!card.classList.contains('is-playing')) playVideo(card);
				} else {
					pauseVideo(card, false);
				}
			});
		}

		/* ---------- Wiring ---------- */

		var scrollTimer;
		track.addEventListener(
			'scroll',
			function () {
				if (isTouch()) updatePlayback();
				window.clearTimeout(scrollTimer);
				scrollTimer = window.setTimeout(updateArrows, 60);
			},
			{ passive: true }
		);

		var vTicking = false;
		window.addEventListener(
			'scroll',
			function () {
				if (!isTouch()) return;
				if (vTicking) return;
				vTicking = true;
				window.requestAnimationFrame(function () {
					updatePlayback();
					vTicking = false;
				});
			},
			{ passive: true }
		);

		function refresh() {
			updateArrows();
			updateFades();
			if (isTouch()) {
				updatePlayback();
			} else {
				// al pasar a desktop, pausa todo (el hover manda)
				cards.forEach(function (c) {
					pauseVideo(c, false);
				});
			}
		}
		refresh();

		var resizeTimer;
		window.addEventListener(
			'resize',
			function () {
				window.clearTimeout(resizeTimer);
				resizeTimer = window.setTimeout(refresh, 150);
			},
			{ passive: true }
		);
	}

	function initAll() {
		document.querySelectorAll('.clxp').forEach(initSection);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', initAll);
})();
